<template>
  <div ref="commentModal">
    <hi-dialog class="caption-dialog" :title="title" @close="closeDialog">
      <div class="top-comment-container">
        <hi-text-area
          v-if="selectPublisher.socialNetwork === 4"
          :placeholder="`write a ${typeText}...`"
          v-model="addTagText"
          style="width: 100%; height: 160px"
          :max="280"
          socialNetwork="twitter"
          ref="textarea"
        ></hi-text-area>
        <hi-text-area
          v-else
          :placeholder="`write a ${typeText}...`"
          v-model="addTagText"
          style="width: 100%; height: 160px"
          :max="30"
          :filterNum="filterNum"
          filterText="#"
          ref="textarea"
        ></hi-text-area>
      </div>
      <div class="main-container">
        <hi-tab
          v-if="selectPublisher.socialNetwork === 1"
          v-model="tabIndex"
          :tabList="tabList"
          class="tab-container"
        ></hi-tab>
        <div class="tag-page">
          <div class="tags-container" v-if="tabIndex === 0">
            <calender-caption
              :key="tag.id"
              @click="commentItemClick"
              :model="tag"
              v-for="tag in list"
            ></calender-caption>
            <div v-if="list.length === 0" class="no-list">Empty</div>
          </div>
          <suggested
            v-if="tabIndex === 1"
            @itemClick="commentItemClick"
          ></suggested>
          <div class="bottom-container">
            <button class="save-btn" @click="saveTag">Save</button>
          </div>
        </div>
      </div>
    </hi-dialog>
  </div>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme";

.caption-dialog {
  width: 375px;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  height: 730px;
  background: #f5f6f7;

  .no-list {
    display: flex;
    font-size: 16px;
    color: gray;
    height: 100%;
    align-items: center;
    justify-content: center;
  }

  .top-comment-container {
    padding: 7px 20px;
    border-bottom: 1px solid #e5e5e5;
    background: white;
  }

  .main-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    background: white;

    textarea {
      border: 0;
      font-size: 14px;
    }

    .tab-container {
      padding: 0 20px;
      border-bottom: 1px solid #e6e6e6;
      text-transform: capitalize;
    }

    .tag-page {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: auto;

      .tags-container {
        flex: 1;
        overflow: auto;
        padding-bottom: 0px;
      }

      .bottom-container {
        background: white;
        border-top: 1px solid @border-color;
        padding: 0 20px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .save-btn {
          width: 98px;
          height: 36px;
          background-color: @theme-color;
          border-radius: 4px;
          color: white;
          font-size: 16px;
          border: 0;

          &:hover {
            opacity: 0.7;
          }
        }
      }
    }
  }
}
</style>

<script>
import hiDialog from "../../common/dialog/Index.vue";
import hiTab from "../../common/tab/Tab";
import hiTextArea from "../../common/form/TextArea.vue";
import suggested from "../../media/schedule/suggested/Suggested";
import { showErrorMsg } from "../../../utils/errors";
import { createUserContent, getUserContent } from "../../../service/publisher";
import {
  CURRENT_PUBLISHER_SIMPLE,
  CURRENT_USER_INFO_SIMPLE,
} from "../../../store/mutation-types";
import store from "../../../store/index";
import calenderCaption from "../../calender/caption/Index.vue";
import { mapGetters } from "vuex";

export default {
  name: "DefaultCaptionAddComponent",
  components: { calenderCaption, hiTextArea, hiDialog, hiTab, suggested },
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    type: {
      // comment caption
      type: String,
    },
    publisherId: {
      default: () => {
        // 如果设置了publisherId则读取设置 否则默认是当前
        return store.getters[CURRENT_PUBLISHER_SIMPLE].publisherId;
      },
    },
  },
  data() {
    return {
      addTagText: "",
      tabIndex: 0,
      list: [],
    };
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    // 获取当前选中的用户信息
    selectPublisher() {
      return this.user.linkedInstagramList.find(
        (l) => l.publisherId === this.publisherId
      );
    },
    tabList() {
      if (this.selectPublisher.socialNetwork !== 4) {
        return [{ title: `History` }, { title: "Suggested #" }];
      } else {
        return [{ title: `History` }];
      }
    },
    typeText() {
      if (this.selectPublisher.socialNetwork === 4) {
        if (this.type === "caption") {
          return "Tweets";
        } else {
          return "Reply";
        }
      } else {
        return this.type;
      }
    },
    title() {
      return `Add New ${this.typeText}`;
    },
    filterNum() {
      const text = this.addTagText;
      const find = [...text].filter((v) => {
        return v === "#";
      });
      return find.length;
    },
  },
  methods: {
    async saveTag() {
      const loading = this.$loading({ target: this.$refs.commentModal });
      try {
        const form = {
          content_type: this.type === "caption" ? 1 : 2,
          content: this.addTagText,
          is_saved: true,
          is_history: false,
        };
        const result = await createUserContent({
          publisherId: this.publisherId,
          form,
        });
        this.$emit("success", result);
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    commentItemClick(item) {
      this.$refs.textarea.addText(item.text);
    },
    /**
     * 关闭dialog点击事件
     */
    async closeDialog() {
      this.$emit("close");
    },
  },
  async created() {
    const loading = this.$loading({ target: this.$refs.commentModal });
    try {
      // 获取当前指定publisher的
      const list = await getUserContent({
        type: this.type,
        publisherId: this.publisherId,
      });
      list.forEach((l) => {
        l.text = l.content;
        l.date = l.date_created;
        l.select = false;
      });
      this.list = list.filter((l) => l.is_history);
    } catch (e) {
      showErrorMsg(e);
    } finally {
      loading.close();
    }
  },
};
</script>
